<template>
  <div class="project-card" @click="goProjectItem(projectInfo.projectCode)">
    <div class="card-left">
      <div class="project-pic">
        <el-image
          style="width: 230px; height: 152px"
          :src="projectInfo.coverPicture"
          fit="cover"></el-image>
      </div>
      <div class="project-con">
        <div class="con-line">
          <div class="project-tit">{{projectInfo.projectName}}</div>
          <div class="project-wx-code" @mouseover="mouseOver" @mouseleave="wxCodeShow = false">
            <img alt="二维码" src="https://cdn.ideamake.cn/de7c722f8399fecc648a1317979eb624/20220528_1014162d4b804b314b4e4587e4624c30a84468.png">
            <transition name="el-zoom-in-top">
              <div class="wx-popu" v-show="wxCodeShow">
                <img alt="二维码" class="wx-img" src="https://cdn.ideamake.cn/de7c722f8399fecc648a1317979eb624/20220525_1657160a1961657b354b839a19c5c8363396a3.png">
                <div class="wx-code">
                  <el-image
                    style="width: 150px; height: 150px"
                    :src="wxCode"
                    fit="cover">
                    <div style="margin-top: 25px;" slot="error" class="image-slot wx-code-loading">
                      <i class="el-icon-loading"></i>
                      <div class="text">加载中</div>
                    </div>
                  </el-image>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="con-text-type">
          <div v-if="projectInfo.mainHouse" class="project-city-type">
            <i class="el-icon-office-building"></i>
            {{projectInfo.mainHouse}}</div>
        </div>
        <div class="con-text">
          <div v-if="cityId !== '3309'" class="project-city">
            <i class="el-icon-location-outline"></i>
            {{projectInfo.city}}{{'·'+projectInfo.district}}｜{{projectInfo.detailAddress}}</div>
        </div>

        <div class="project-tip">
            <div class="tip-item" v-for="(tag, index) in projectInfo.tags" :key="index">{{ tag }}</div>
        </div>
      </div>
    </div>
    <div class="project-price">
      {{ projectPrice }}
      <span>{{ projectPriceUnit }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProjectCard",
  props: {
    projectInfo: {
      type: Object,
      default: () => ({}),
    },
    cityId: {
      type: String,
    },
  },
  data () {
    return {
      wxCode: null,
      wxCodeShow: false,
      timer: null,
    }
  },
  computed: {
    projectPrice () {
      let {
        averagePrice, averagePriceUnit, displayPriceType,
        lowestTotalPrice, topTotalPrice, totalPriceUnit,
      } = this.projectInfo
      averagePrice = averagePrice || '--'
      lowestTotalPrice = lowestTotalPrice || '-'
      topTotalPrice = topTotalPrice || '-'
      const totalType = `${lowestTotalPrice}-${topTotalPrice}`
      const averageType = `${averagePrice}`
      if (displayPriceType === 2) {
        return totalPriceUnit && totalPriceUnit.indexOf('待定') !== -1 ? '价格待定': totalType
      } else {
        return averagePriceUnit && averagePriceUnit.indexOf('待定') !== -1 ? '价格待定': averageType
      }
    },
    projectPriceUnit () {
      let { averagePriceUnit,  totalPriceUnit, displayPriceType } = this.projectInfo
      averagePriceUnit = averagePriceUnit || '均价（元/平）'
      totalPriceUnit = totalPriceUnit || '万元/套'
      if (displayPriceType === 2) {
        return totalPriceUnit && totalPriceUnit.indexOf('待定') !== -1 ? '': totalPriceUnit
      } else {
        return averagePriceUnit && averagePriceUnit.indexOf('待定') !== -1 ? '': averagePriceUnit
      }
    },
  },
  methods: {
    mouseOver(){
      const projectCode = this.projectInfo.projectCode
      this.wxCodeShow = true
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.wxCode) {
          return
        }
        this.getWxaCode(projectCode)
      }, 500);
    },
    // 生成小程序二维码
    getWxaCode(projectCode){
      const url = `pages/exhibitionHall/multiProject/detail?projectCode=${projectCode}`
      this.$api.getWxaCode(url).then(res => {
        const wxCode = res.data
        this.wxCode = wxCode
      })
    },
    // 调整项目详情
    goProjectItem(projectCode){
      this.getWxaCode(projectCode)
      this.$router.push({ path: '/projectDetail', query:{projectCode} })
    }
  },

}
</script>
<style lang="scss" scoped>
.project-card{
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  .card-left{
    display: flex;
    .project-pic{
      width: 230px;
      height: 152px;
      background-color: #9399A5;
    }
  }
  .project-con{
    margin-left: 32px;
    .con-line{
      display: flex;
      .project-tit{
        @include font18(500, #333333);
        font-size: 22px;
        margin-right: 10px;
      }
      .project-wx-code{
        cursor: pointer;
        width: 24px;
        height: 24px;
        position: relative;
        .wx-popu{
          position: absolute;
          top: 20px;
          left: -84px;
          width: 138px;
          height: 191px;
          z-index: 9;
          .wx-img{
            width: 192px;
            height: 244px;
          }
          .wx-code{
            width: 150px;
            height: 150px;
            background-color: #fff;
            position: absolute;
            top: 33px;
            left: 21px;
          }
        }
        img{
          width: 24px;
          height: 24px;
        }
      }
      .project-city{
        margin-top: 6px;
        @include font14(400, #9399A5);
      }
    }
    .con-text-type {
      box-sizing: border-box;
      padding-top: 25px;
      .project-city-type{
        @include font14(400, #9399A5);
      }
    }
    .con-text{
      padding-top: 10px;
      padding-bottom: 25px;
      // height: 96px;
      // padding: 20px 0 5px 0;
      box-sizing: border-box;
      .project-city{
        @include font14(400, #9399A5);
      }
    }
    .project-tip{
      display: flex;
      .tip-item{
        margin-right: 10px;
        width: auto;
        height: 30px;
        background: rgba(255, 240, 211, 0.5);
        border-radius: 2px;
        @include font12(400, #BDA26C);
        line-height: 30px;
        padding: 0 12px;
      }
    }
  }
  .project-price{
    padding-right: 20px;
    @include font28(500, #FA5741);
    span {
      @include font18(500, #FA5741);
    }
  }
}
</style>
